//index.ts
import { LangStrMap } from '@/constants/locales'
import { computed } from 'vue'
//引入vue-i18n组件
import { createI18n } from 'vue-i18n'
// 英文语言配置
import enUS from './en-US/index.ts'
// 中文（HK）语言配置
import zhHK from './zh-HK/index.ts'
// 引入子模块的公共多语言
import commonEnUs from '@/common/src/locales/en-US/index.ts'
import commonZhHk from '@/common/src/locales/zh-HK/index.ts'
// 引入子模块的常量
import { LOCAL_LANG_KEY_PINGTAI } from '@/common/src/constants/system-constant.ts'
// import { en as commonEn, zhCN as commonZhCN } from '@/common/locales'
// console.log('commonEnUs == ', commonEnUs)
// console.log('commonZhHk == ', commonZhHk)
/**
 * 判断语言当前
 * @param {Object} mList
 */
function getLanguage(): string {
  // const login = storeToRefs(useLogin())
  // console.log('login- == ', login)
  let defaultLan: string = 'zh-HK'
  const type = navigator.appName
  if (type == 'Netscape') {
    defaultLan = navigator.language //获取浏览器配置语言，支持非IE浏览器
  } else {
    defaultLan = navigator['userLanguage'] //获取浏览器配置语言，支持IE5+ == navigator.systemLanguage
  }
  // defaultLan = 'en-CA' // 加拿大
  // 'zh-TW'的改为'zh-HK'
  if (defaultLan === 'zh-TW') {
    defaultLan = 'zh-HK'
  }
  // 海外默认繁体
  console.log(
    '!LangStrMap.includes(defaultLan) == ',
    !LangStrMap.includes(defaultLan),
    defaultLan,
  )
  if (!LangStrMap.includes(defaultLan)) {
    defaultLan = 'zh-HK'
  }
  // var lang = lang.substr(0, 2);//获取浏览器配置语言前两位
  // return login.currentLang.value || defaultLan
  let localLang: any = localStorage.getItem(LOCAL_LANG_KEY_PINGTAI)
  if (!LangStrMap.includes(localLang)) {
    localLang = 'zh-HK'
  }
  const language: string = localLang || defaultLan || 'zh-HK' // 这是获取浏览器的语言
  // const language: string = defaultLan || localLang || 'zh-HK' // 这是获取浏览器的语言
  // const language: string = defaultLan // 这是获取浏览器的语言
  console.log('language- == ', language)
  localStorage.setItem(LOCAL_LANG_KEY_PINGTAI, language)
  return language
}
// console.log('getLangAll().index == ', getLangAll().index)
// console.log('zhHK == ', zhHK)
// 合并公共多语言和项目自有多语言
const messages = {
  'zh-HK': { ...commonZhHk, ...zhHK },
  'en-US': { ...commonEnUs, ...enUS },
}
console.log('messages == ', messages)

// 创建 i18n 实例并赋值给变量
const i18n = createI18n({
  globalInjection: true,
  legacy: false, // 启用 composition API 模式
  locale: getLanguage(),
  messages: messages,
})

// 导出 i18n 实例和全局 t 函数（关键：供非组件文件使用）
export const { t } = i18n.global

export const currentLocale = computed(() => i18n.global.locale.value)
export const isEn = computed(() => currentLocale.value === 'en-US')

export default i18n
